import React from "react"
import types from "prop-types"

const PaginationLoadingStatus = ({ loadedCount, totalCount }) => (
  <span>
    {loadedCount} / {totalCount}
  </span>
)

PaginationLoadingStatus.propTypes = {
  loadedCount: types.number.isRequired,
  totalCount: types.number.isRequired,
}

export default PaginationLoadingStatus
